import React from "react";
import "../OrderComponents/OrderTabs.css";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useLocation, NavLink } from "react-router-dom";
import BulkStockPopup from "../common/BulkStockPopup";

const InventoryTabs = (props) => {
  const stateData = useSelector((state) => state);
  const inventoryCount = stateData?.ActionReducer?.inventoryCount;
  const actionRequired = inventoryCount?.actionRequired ?? props?.actionRequired ?? 0;
  const weightVerificationCnt = inventoryCount?.weightVerification ?? props?.weightVerificationCnt ?? 0;
  const [ordersCount, setOrdersCount] = useState(null);
  const location = useLocation();
  var path = location.pathname.split("/");
  const pageName = path[path.length - 1];
  useEffect(() => {
    setOrdersCount(stateData?.ActionReducer?.ordersCount);
  }, [stateData.ActionReducer]);

  return (
    <div className="inv_tab_cntn_outer">
      <div className="inv_tab_cntn_inner" style={{ position: "relative" }}>

        <NavLink
          to="all-products"
          className={`tabItem ${pageName == "all-products" ? "active" : ""}`}
        >
          <i className="bi bi-box-seam"></i>
          All Products
          {props?.allRec > 0 && (
            <div className="menu-count menu-count-border">
              {props?.allRec || 0}
            </div>
          )}
        </NavLink>

        <NavLink
          to="active"
          className={`tabItem ${pageName == "active" ? "active" : ""}`}
        >
          <i className="bi bi-box-seam"></i>
          Active Products
          {props?.activeRec > 0 && (
            <div className="menu-count menu-count-border">
              {props?.activeRec || 0}
            </div>
          )}
        </NavLink>

        <NavLink
          to="outofstock"
          className={`tabItem ${pageName == "outofstock" ? "active" : ""}`}
        >
          <i className="bi bi-box-seam"></i>
          Out of Stock Products
          {props?.outOfStockRec > 0 && (
            <div className="menu-count menu-count-border">
              {props?.outOfStockRec || 0}
            </div>
          )}
        </NavLink>
       {actionRequired > 0 && (
          <NavLink
            to="actionrequired"
            className={`tabItem ${pageName == "actionrequired" ? "active" : ""}`}
          >
            <i className="bi bi-exclamation-circle"></i>
            {/* Action Required */}
            Transfer price Change Requests
            <div className="menu-count menu-count-border" style={{backgroundColor: 'red',color:'white'}}>
              {actionRequired}
            </div>
          </NavLink>
        )}

        {weightVerificationCnt > 0 && (
          <NavLink
            to="weightverification"
            className={`tabItem ${pageName == "weightverification" ? "active" : ""}`}
          >
            <i className="bi bi-funnel"></i>
            Weight Verification
            <div className="menu-count menu-count-border">
              {weightVerificationCnt}
            </div>
          </NavLink>
        )}

        {/* Blocked Products tab — unique "Cancelled" pill style */}
        {props?.blockedProductsRec > 0 && (
  <NavLink
    to="blocked"
    className={`tabItem ${pageName == "blocked" ? "active" : ""}`}
    
  >
    <i
      className="bi bi-shield-exclamation"
      style={{ marginRight: "5px" }}
    ></i>
    Blocked Products
    {props?.blockedProductsRec > 0 && (
            <div className="menu-count menu-count-border">
              {props?.blockedProductsRec || 0}
            </div>
          )}
  </NavLink>
)}

      </div>
    </div>
  );
};

export default InventoryTabs;